import { http } from '@/utils/http';
import qs from 'qs';
// 保存留言
export function CommentSave(
  voteName: string,
  data: {
    appkey: string | number | undefined;
    udid: string | number | undefined;
    content: string;
  },
) {
  const qsData = qs.stringify(data);
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=comment-save',
    qsData,
  );
}

// 留言列表
export function CommentList(voteName: string, page: number) {
  return http.get('/vote/' + voteName + '/controller.php?enews=comment-list', {
    params: { page },
  });
}

// 节目下拉菜单
export function ProgramTree(voteName: string) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=annual_program_tree',
  );
}

// 节目列表
export function ProgramList(voteName: string, search?: string) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=annual_program_list',
    {
      params: { search },
    },
  );
}
// 演员列表
export function PersonalList(voteName: string, search?: string, type?: any) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=annual_personal_list',
    {
      params: { search, type },
    },
  );
}
// 节目详情
export function ProgramDetail(voteName: string, id?: any) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=annual_program_detail',
    {
      params: { id },
    },
  );
}
// 演员投票树
export function PersonalTree(voteName: string) {
  const qsData = qs.stringify({ appkey: window.appkey, udid: window.udid });
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=annual_personal_tree',
    qsData,
  );
}
// 演员详情
export function PersonalDetail(voteName: string, id: any) {
  return http.get(
    '/vote/' + voteName + '/controller.php?enews=annual_personal_detail',
    {
      params: { id },
    },
  );
}
// 节目投票
export function ProgramVote(
  voteName: string,
  votes: any,
  data: {
    udid?: any;
    appkey?: any;
    csessionid?: string;
    scene?: string;
    sig?: string;
    token?: string;
  },
) {
  const lastVote = JSON.stringify(votes);
  const qsData = qs.stringify(data, { encode: false });
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=annual_program_vote',
    'votes=' + lastVote + '&' + qsData,
  );
}
// 演员投票

export function PersonalVote(
  voteName: string,
  votes: any,
  data: {
    udid?: any;
    appkey?: any;
    csessionid?: string;
    scene?: string;
    sig?: string;
    token?: string;
  },
) {
  const lastVote = JSON.stringify(votes);
  const qsData = qs.stringify(data);
  return http.post(
    '/vote/' + voteName + '/controller.php?enews=annual_personal_vote',
    'votes=' + lastVote + '&' + qsData,
  );
}
